<style>
.el-collapse-item__header {
    padding-left: 15px;
}

.el-upload--picture-card {
    float: left;
    margin-right: 10px;
}

.circle-closesty {
    position: relative;
    top: -35px;
    margin-left: 112px;
    font-size: 20px;
    cursor: pointer;
}

.v-modal {
    z-index: 100 !important;
}

.select-box {
    overflow: hidden;
    margin: 0 0px 10px 30px;
}

.box-left {
    width: 40%;
    height: 350px;
    padding: 0 20px 20px 20px;
    border: 1px solid #bbb;
    box-sizing: border-box;
    overflow-y: auto;
}

.box-right {
    width: 57%;
    height: 350px;
    padding: 0 10px 20px 20px;
    border: 1px solid #bbb;
    box-sizing: border-box;
}

.state {
    color: #1BA854;
    width: 32px;
    height: 22px;
    background: #F2FFF5;
    border: 1px solid rgba(220, 250, 228, 1);
    border-radius: 2px;
    display: inline-block;

}

.no-state {
    color: #666;
    width: 32px;
    height: 22px;
    background: #F5F5F5;
    border: 1px solid #f9f9f9;
    border-radius: 2px;
    display: inline-block;

}
</style>
<template>
    <div class="content">
        <div class="search-area">
            <el-row :gutter="24">
                <el-col :span="6">
                    <div class="search-area-div">业务功能</div>
                    <el-input v-model="page.functionName" size="mini" class="ipt-sty" placeholder="请输入任务大类"></el-input>
                </el-col>
                <el-col :span="4" class="search-btn-box">
                    <el-button size="mini" type="info" @click="search">搜索</el-button>
                    <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
            <div class="button-area">
                <el-button icon="el-icon-plus" size="mini" type="info" @click="toConfig">添加配置</el-button>
            </div>
            <el-table :data="tableData" stripe style="width: 100%" v-loading="tableLoading" :height="height">
                <el-table-column label="序号" width="60" header-align="center" align="center">
                    <template slot-scope="scope">
                        <!-- {{ scope.$index + 1 }} -->
                        {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column label="业务功能" show-overflow-tooltip header-align="center" align="left">
                    <template slot-scope="scope">{{ scope.row.functionName }}</template>
                </el-table-column>
                <el-table-column label="启用状态" show-overflow-tooltip header-align="center" align="center">
                    <template slot-scope="scope">
                        <span class="state" v-if="scope.row.effective == 1">启用</span>
                        <span class="no-state" v-else>停用</span>
                    </template>
                </el-table-column>

                <el-table-column label="操作人" header-align="center" align="left">
                    <template slot-scope="scope">{{ scope.row.operator || '-' }}</template>
                </el-table-column>
                <el-table-column label="操作时间" header-align="center" align="left">
                    <template slot-scope="scope">{{ scope.row.operationTime | getTimeDate }}</template>
                </el-table-column>
                <el-table-column width="140px" label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <a class="txt-color" v-if="scope.row.effective != 1" @click="modifyState(scope.row, 1)">启用｜</a>
                        <a class="txt-color" v-else @click="modifyState(scope.row, 0)">停用｜</a>
                        <a class="txt-color" @click="editConfig(scope.row)">编辑 ｜</a>
                        <a class="txt-color" @click="delVersion(scope.row.guid)">删除</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :current-page="page.pageIndex"
            :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
        </el-pagination>
    </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
    data() {
        return {
            fullscreenLoading: false,
            page: {
                pageIndex: 1,
                pageSize: 50,
                totalPage: 0,
                totalRows: 0,
                functionName: '',
            },
            paramName: '',
            height: window.innerHeight - 280,
            contentMainHeight: window.innerHeight - 200,
            right: 'right',
            tableData: [],
            dialogVisible: false,
        };
    },
    created() {
        this.getList();
    },
    watch: {},
    methods: {
        search() {
            let self = this;
            this.page.pageIndex = 1;
            self.tableLoading = true;
            self.api.postJson(`/${serverConfig.msConfigureService}/rosterplatform/func-datamapping-config/pageListFuncDatamappingConfig`, this.page).then((res) => {
                self.tableLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    self.tableData = res.data.data.records;
                    self.page.totalPage = res.data.data.totalPages;
                    self.page.totalRows = res.data.data.totalRows;
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
        emptySearch() {
            this.page = {
                pageIndex: 1,
                pageSize: 50,
                totalPage: 0,
                totalRows: 0,
                functionName: '',
            };
            this.getList();
        },
        toConfig() {
            this.$router.push('/configEdit')
        },
        editConfig(obj) {
            this.$router.push({
                path: 'configEdit', query: {
                    guid: obj.guid,
                    functionGuid: obj.functionGuid
                }
            })
        },
        getList() {
            let self = this;
            self.tableLoading = true;
            self.api.postJson(`/${serverConfig.msConfigureService}/rosterplatform/func-datamapping-config/pageListFuncDatamappingConfig`, this.page).then((res) => {
                self.tableLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    self.tableData = res.data.data.records;
                    self.page.totalPage = res.data.data.totalPages;
                    self.page.totalRows = res.data.data.totalRows;
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
        delVersion(guid) {
            var self = this;
            self
                .$confirm('删除后不可恢复，确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                .then(() => {
                    let req = [guid];
                    self.api.postJson(`/${serverConfig.msConfigureService}/rosterplatform/func-datamapping-config/deleteFuncDatamappingConfig`, req).then((res) => {
                        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                            self.$message.success('删除成功');
                            self.page.pageIndex = 1;
                            self.getList();
                        } else {
                            self.$message.error(res.data.msg);
                        }
                    });
                });
        },
        modifyState(obj, effective) {
            let req = {
                guid:obj.guid,
                effective,
                funcGuid:obj.functionGuid
            };
            this.tableLoading = true;
            this.api.postJson(`/${serverConfig.msConfigureService}/rosterplatform/func-datamapping-config/createOrUpdateFuncDatamappingConfig`, req).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.$message.success(effective == 1 ? '启用成功' : '停用成功');
                    this.getList();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        handleSizeChange(val) {
            let self = this;
            self.page.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            let self = this;
            self.page.pageIndex = val;
            this.getList();
        },
    },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
}

.el-range-editor.el-input__inner {
    padding: 0px;
}

/deep/ .el-checkbox__label {
    display: none;
}

.attach-sty {
    width: 170px;
    float: left;
    margin-top: 15px;
    text-align: center;
}

.checkbox-img-sty {
    border: 1px solid #dcdfe6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
}

/deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color: #4fa1a4;
    border-color: inherit;
}

/deep/ .el-step__icon-inner {
    color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
</style>